/*=========================================================================================
  File Name: module-navigation.js
  Description: Navigation Module — lưu trữ flag điều hướng tạm thời (ephemeral)
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-navigation-state';
import mutations from './module-navigation-mutations';
import actions from './module-navigation-actions';
import getters from './module-navigation-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state: state,
	mutations: mutations,
	actions: actions,
	getters: getters
};
